import { createAction, props } from '@ngrx/store';
import { PaymentStatusEnum } from 'src/app/enums/payment-status.enum';
import { SDDTransactionTypeEnum } from 'src/app/enums/sdd-transaction-type.enum';
import { Deposit } from 'src/app/models/deposit.model';
import { DepositDetails } from 'src/app/models/deposits-details.model';
import { EBillsRelationshipModel } from 'src/app/models/e-bills-relationship.model';
import { EBillsServiceModel } from 'src/app/models/e-bills-service.model';
import { eBillsModel } from 'src/app/models/e-bills.model';
import { FilterEBillsServices } from 'src/app/models/filter-e-bills-services.model';
import { Loan } from 'src/app/models/loan.model';
import { Saving } from 'src/app/models/saving.model';
import { SDDLimitDetails } from 'src/app/models/sdd-limit-details.model';
import { SDDTransactionDetails } from 'src/app/models/sdd-transaction-details.model';
import { AccountDetails } from '../../../models/account-details.model';
import { AccountTransactionFilter } from '../../../models/account-transaction-filter.model';
import { Account } from '../../../models/account.model';
import { Statement } from '../../../models/statement.model';
import { SavingsDetails } from './../../../models/saving-details.model';
import { Transaction } from './../../../models/transaction.model';
import { FilterEBillsSubscribed } from 'src/app/models/filter-e-bills-subscribed.model';
import { ReceivedSentEnum } from 'src/app/enums/received-sent.enum';

// Page Actions
export const layoutSelectActiveAccount = createAction(
  '[Layout Component] Active account selection',
  props<{ selectedAccount: Account | null }>()
);
export const layoutSelectActiveLoan = createAction(
  '[Layout Component] Active loan selection',
  props<{ selectedLoan: Loan | null }>()
);
export const layoutSelectActiveSaving = createAction(
  '[Layout Component] Active saving selection',
  props<{ selectedSaving: Saving | null }>()
);

export const layoutSelectActivePrepaid = createAction(
  '[Layout Component] Active prepaid selection',
  props<{ selectedPrepaid: Account | null }>()
);

export const layoutSelectActiveDeposit = createAction(
  '[Layout Component] Active deposit selection',
  props<{ selectedDeposit: Deposit | null }>()
);

export const cardDropdownComponentSelectActiveAccount = createAction(
  '[Card Dropdown Component] Active account selection',
  props<{ selectedAccount: Account | null }>()
);

export const standardAccountSelectActiveAccount = createAction(
  '[Standard Account Component] Active account selection',
  props<{ selectedAccount: Account | null }>()
);

export const standardAccountSelectActiveLoan = createAction(
  '[Standard Account Component] Active loan selection',
  props<{ selectedLoan: Loan | null }>()
);

export const standardAccountSelectActiveSaving = createAction(
  '[Standard Account Component] Active saving selection',
  props<{ selectedSaving: Saving | null }>()
);

export const standardAccountSelectActivePrepaid = createAction(
  '[Standard Account Component] Active prepaid selection',
  props<{ selectedPrepaid: Account | null }>()
);

export const standardAccountSelectActiveDeposit = createAction(
  '[Standard Account Component] Active deposit selection',
  props<{ selectedDeposit: Deposit | null }>()
);

export const accountsComponentSelectActiveAccount = createAction(
  '[Accounts Component] Active account selection',
  props<{ selectedAccount: Account | null }>()
);

export const loansComponentSelectActiveAccount = createAction(
  '[Loans Component] Active loan selection',
  props<{ selectedLoan: Loan | null }>()
);

export const savingsComponentSelectActiveAccount = createAction(
  '[Savings Component] Active saving selection',
  props<{ selectedSaving: Saving | null }>()
);

export const prepaidComponentSelectActiveAccount = createAction(
  '[Savings Component] Active saving selection',
  props<{ selectedPrepaid: Account | null }>()
);

export const depositsComponentSelectActiveAccount = createAction(
  '[Deposits Component] Active deposit selection',
  props<{ selectedDeposit: Deposit | null }>()
);

export const paymentsComponentSelectActiveAccount = createAction(
  '[Payments Component] Active account selection',
  props<{ selectedAccount: Account | null }>()
);

export const loadAccountDetailsSuccess = createAction(
  '[Account Details Component] Load account details success',
  props<{ accountDetails: AccountDetails | null }>()
);
export const loadAccountDetailsFailure = createAction(
  '[Account Details Component] Load account details Failure',
  props<{ error: any }>()
);

export const loadSavingDetailsSuccess = createAction(
  '[Saving Details Component] Load saving details success',
  props<{ savingDetails: SavingsDetails | null }>()
);
export const loadDepositDetailsSuccess = createAction(
  '[Deposit Details Component] Load deposit details success',
  props<{ depositDetails: DepositDetails | null }>()
);
export const loadSavingDetailsFailure = createAction(
  '[Saving Details Component] Load saving details Failure',
  props<{ error: any }>()
);
export const loadLoanDetailsSuccess = createAction(
  '[Loan Details Component] Load loan details success',
  props<{ loanDetails: AccountDetails | null }>()
);

export const loadLoanDetailsFailure = createAction(
  '[Loan Details Component] Load loan details Failure',
  props<{ error: any }>()
);

export const loadTransactionHistorySuccess = createAction(
  '[Account Transactions Component] Load account transactions history success',
  props<{ accountTransactions: Transaction[] | null }>()
);
export const loadSavingsTransactionHistorySuccess = createAction(
  '[Account Transactions Component] Load account transactions history success',
  props<{ savingsTransactions: Transaction[] | null }>()
);

export const loadAnnouncementHistorySuccess = createAction(
  '[Account Announcement Component] Load account Announcement history success',
  props<{ accountAnnouncements: Transaction[] | null }>()
);

export const loadEBillsListSuccess = createAction(
  '[E-Bills List Component] Load E-Bills List success',
  props<{ eBillTransactions: eBillsModel[] | null }>()
);

export const loadSDDListSuccess = createAction(
  '[SDD List Component] Load SDD List success',
  props<{ sddTransactions: SDDTransactionDetails[] | null }>()
);
export const loadSDDListFailure = createAction(
  '[SDD List Component] Load SDD List failure'
);
export const loadSDDLimitsSuccess = createAction(
  '[SDD Limits Component] Load SDD Limits success',
  props<{ sddLimits: SDDLimitDetails[] | null }>()
);
export const loadSDDLimitsFailure = createAction(
  '[SDD Limits Component] Load SDD Limits failure'
);

export const loadEBillsServicesListSuccess = createAction(
  '[E-Bills Services List Component] Load E-Bills Services List success',
  props<{ eBillsServicesList: EBillsServiceModel[] | null }>()
);
export const loadEBillsSubscribedListSuccess = createAction(
  '[E-Bills Subscribed List Component] Load E-Bills Subscribed List success',
  props<{ eBillsSubscribedList: EBillsRelationshipModel[] | null }>()
);
export const resetTransactionHistory = createAction(
  '[Account Transactions Component] Reset account transactions history'
);

export const loadTransactionHistoryFailure = createAction(
  '[Account Transactions Component] Load account transactions history Failure',
  props<{ error: any }>()
);

export const changeAccountName = createAction(
  '[Change Account Name Component] Change account name',
  props<{ accountName: string; accountId: string }>()
);

export const loadUnsignedOrdersSuccess = createAction(
  '[Account Unsigned orders Component] Load account unsigned orders success',
  props<{ unsignedOrders: Transaction[] | null }>()
);
export const resetUnsignedOrders = createAction(
  '[Account Unsigned orders Component] Reset account unsigned orders '
);
export const loadUnsignedOrdersFailure = createAction(
  '[Account Unsigned orders Component] Load account unsigned orders Failure',
  props<{ error: any }>()
);

export const loadAccountStatementsSuccess = createAction(
  '[Account Statements Component] Load account statements success',
  props<{ accountStatements: Statement[] | null }>()
);
export const resetAccountStatements = createAction(
  '[Account Statements Component] Reset account statements'
);

export const loadAccountStatementsFailure = createAction(
  '[Statements Effect] Statements load Failure',
  props<{ error: any }>()
);

export const changeAccountActiveCurrency = createAction(
  '[Standard Account Component] Change account currency',
  props<{ accountId: string; activeBalance: any }>()
);
export const changeSavingActiveCurrency = createAction(
  '[Standard Account Component] Change saving currency',
  props<{ accountId: string; activeBalance: any }>()
);
export const changeLoanActiveCurrency = createAction(
  '[Standard Account Component] Change loan currency',
  props<{ accountId: string; activeBalance: any }>()
);
export const changeDepositActiveCurrency = createAction(
  '[Standard Account Component] Change deposit currency',
  props<{ accountId: string; activeBalance: any }>()
);

export const accountFilterTransaction = createAction(
  '[Account Filter Transaction] Filter account transactions',
  props<{ accountTransactionsFilters: AccountTransactionFilter }>()
);

export const savingsFilterTransaction = createAction(
  '[Savings Filter Transaction] Filter savings transactions',
  props<{ savingsTransactionsFilters: AccountTransactionFilter }>()
);

export const accountFilterEBills = createAction(
  '[Account Filter e-bills] Filter account e-bills',
  props<{ paymentStatus: PaymentStatusEnum, receivedSentEnum: ReceivedSentEnum }>()
);
export const sddTransactionTypeFilters = createAction(
  '[Account Filter SDD] Filter account SDD',
  props<{
    sddTransactionType: SDDTransactionTypeEnum;
    paymentDateFrom: string;
    paymentDateTo: string;
  }>()
);

export const accountFilterTransactionFromDetails = createAction(
  '[Account Details Filter Transaction] Filter account transactions',
  props<{ accountTransactionsFilters: AccountTransactionFilter }>()
);

export const accountFilterTransactionFromAccounts = createAction(
  '[Accounts Filter Transaction] Filter account transactions',
  props<{ accountTransactionsFilters: AccountTransactionFilter }>()
);

export const accountFilterAnnouncements = createAction(
  '[Accounts Filter Announcements] Filter account announcements',
  props<{ accountAnnouncementsFilters: AccountTransactionFilter }>()
);
export const accountFilterStatements = createAction(
  '[Accounts Filter Statements] Filter account statements',
  props<{ accountStatementsFilters: AccountTransactionFilter }>()
);

export const accountFilterUnsignedOrders = createAction(
  '[Account Filter Unsigned Orders] Filter account unsigned orders',
  props<{ accountUnsignedOrdersFilters: AccountTransactionFilter }>()
);

export const accountFilterUnsignedOrdersFromDetails = createAction(
  '[Account Details Filter Unsigned Orders] Filter account unsigned orders',
  props<{ accountUnsignedOrdersFilters: AccountTransactionFilter }>()
);

export const resetFilterTransaction = createAction(
  '[Account Filter Transaction] Reset filter account transactions'
);

export const resetFilterSavingsTransaction = createAction(
  '[Savings Filter Transaction] Reset filter savings transactions'
);
export const resetAnnouncementFilterTransaction = createAction(
  '[Account Announcement Filter Transaction] Reset Announcement filter account transactions'
);

export const resetFilterStatements = createAction(
  '[Account Filter Statements] Reset filter account statements'
);

export const resetFilterUnsignedOrders = createAction(
  '[Account Filter Unsigned Orders] Reset filter account unsigned orders'
);

export const selectedAccountUnsignedOrders = createAction(
  '[Account Unsigned OrderId Component] Unsigned ordersId component',
  props<{ data: Transaction | null }>()
);

export const resetSelectedAccountUnsignedOrders = createAction(
  '[Account  Reset Unsigned OrderId  Component] Reset Unsigned ordersId component'
);

export const setAccountTransactionDetails = createAction(
  '[Account Transaction History] Set Active Account Transaction',
  props<{ accountTransactionDetails: Transaction | null }>()
);
export const setSavingsTransactionDetails = createAction(
  '[Savings Transaction History] Set Active Savings Transaction',
  props<{ savingsTransactionDetails: Transaction | null }>()
);

export const setEBillsDetails = createAction(
  '[E-Bills List] Set Active E-Bills',
  props<{ eBillsDetails: any | null }>()
);
export const setEBillsFileDetails = createAction(
  '[E-Bills Document] Set Active E-Bills File',
  props<{ eBillsFileDetails: any | null }>()
);
export const setSDDDetails = createAction(
  '[Sdd Details] Set Active SDD',
  props<{ sddDetails: SDDTransactionDetails | null }>()
);
export const setSDDLimitsDetails = createAction(
  '[Sdd Limits Details] Set Active SDD Limits',
  props<{ sddLimitsDetails: SDDLimitDetails | null }>()
);
export const setEBillsServiceDetails = createAction(
  '[E-Bills List] Set Active E-Bills Service',
  props<{ eBillsServiceDetails: any | null }>()
);
export const filterEBillsServices = createAction(
  '[E-Bills Filter Services] Filter E-Bills Services',
  props<{ eBillsServicesFilters: FilterEBillsServices }>()
);

export const filterEBillsSubscribed = createAction(
  '[E-Bills Filter Subscribed] Filter E-Bills Subscribed',
  props<{ eBillsSubscribedFilters: FilterEBillsSubscribed }>()
);

export const resetAccountTransactionDetails = createAction(
  '[Account Transaction Details] Reset Active Account Transaction'
);

export const resetSavingsTransactionDetails = createAction(
  '[Savings Transaction Details] Reset Active Savings Transaction'
);

export const setPrepaidIban = createAction(
  '[Prepaid Internal Transfer] Set Prepaid Iban',
  props<{ prepaidIban: any | null }>()
);

// API actions
export const loadAccountDetailsApi = createAction(
  '[Account Details Component API] Load account details'
);
export const loadSavingDetailsApi = createAction(
  '[Saving Details Component API] Load saving details'
);
export const loadGradualSavingDetailsApi = createAction(
  '[Gradual Saving Details Component API] Load gradual saving details'
);

export const loadDepositDetailsApi = createAction(
  '[Deposit Details Component API] Load deposit details'
);

export const loadLoanDetailsApi = createAction(
  '[Loan Details Component API] Load loan details'
);

export const loadTransactionHistoryApi = createAction(
  '[Account Transactions Component API] Load account transactions history'
);

export const loadSavingsTransactionHistoryApi = createAction(
  '[Savings Transactions Component API] Load savings transactions history'
);

export const loadAnnouncementHistoryApi = createAction(
  '[Account Announcements Component API] Load account announcements history'
);

export const loadEBillsListApi = createAction(
  '[EBills List Component API] Load E-Bills list'
);
export const loadEbillsDetailsApi = createAction(
  '[EBills Details Component API] Load EBills details'
);
export const loadEBillsServicesListApi = createAction(
  '[EBills Services List Component API] Load E-Bills Services list'
);
export const loadEBillsSubscribedListApi = createAction(
  '[EBills Subscribed List Component API] Load E-Bills Subscribed list'
);
export const changeEBillsSubscription = createAction(
  '[EBills List Component API] Change E-Bills Subscription',
  props<{ eBillsSubscription: EBillsRelationshipModel }>()
);
export const loadUnsignedOrdersApi = createAction(
  '[Account Unsigned orders Component API] Load account unsigned orders'
);

export const loadAccountStatementsApi = createAction(
  '[Account Statements Component API] Load account statements'
);

export const loadSDDListApi = createAction(
  '[SDD List Component API] Load SDD list'
);

export const loadSDDLimitsApi = createAction(
  '[SDD Limit Component API] Load SDD Limit'
);
